import styled from 'styled-components'

import {
  IR_MANAGE_ROUTE,
  IR_GOVERNANCE_ROUTE,
  IR_FINANCIAL_ROUTE,
  IR_LIBRARY_ROUTE,
  // IR_INVESTOR_ROUTE,
  IR_STOCK_ROUTE,
  IR_OTHER_ROUTE,
} from '@/utils/enroutes'

import { IrSiteMap } from './IrSiteMap'

export const IrSiteMapLink = () => {
  return (
    <Wrapper>
      <SiteMapList minHeight="regular">
        <IrSiteMap
          parent={{ path: IR_MANAGE_ROUTE.path, name: IR_MANAGE_ROUTE.name }}
          subdirectories={IR_MANAGE_ROUTE.subdirectories}
        />
        <IrSiteMap
          parent={{
            path: IR_GOVERNANCE_ROUTE.path,
            name: IR_GOVERNANCE_ROUTE.name,
          }}
          subdirectories={IR_GOVERNANCE_ROUTE.subdirectories}
        />
        <IrSiteMap
          parent={{
            path: IR_FINANCIAL_ROUTE.path,
            name: IR_FINANCIAL_ROUTE.name,
          }}
          subdirectories={IR_FINANCIAL_ROUTE.subdirectories}
        />
      </SiteMapList>
      <SiteMapList minHeight="high">
        <IrSiteMap
          parent={{ path: IR_LIBRARY_ROUTE.path, name: IR_LIBRARY_ROUTE.name }}
          subdirectories={IR_LIBRARY_ROUTE.subdirectories}
        />
        {/* <IrSiteMap
          parent={{
            path: IR_INVESTOR_ROUTE.path,
            name: IR_INVESTOR_ROUTE.name,
          }}
          subdirectories={IR_INVESTOR_ROUTE.subdirectories}
        /> */}
        <IrSiteMap
          parent={{ path: IR_STOCK_ROUTE.path, name: IR_STOCK_ROUTE.name }}
          subdirectories={IR_STOCK_ROUTE.subdirectories}
        />
      </SiteMapList>
        <IrSiteMap
          parent={{ name: IR_OTHER_ROUTE.name }}
          subdirectories={IR_OTHER_ROUTE.subdirectories}
          isLast
        />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 46px;

  @media screen and (max-width: 1047px) {
    gap: 14px;
  }
`

const SiteMapList = styled.div<{ minHeight: 'regular' | 'high' }>`
  display: flex;
  gap: 46px;
  height: 100%;

  @media screen and (max-width: 1047px) {
    flex: 1;
    flex-direction: column;
    gap: 14px;
  }
`
